var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cloth",class:{'active': _vm.act == true}},[_c('button',{on:{"click":_vm.change}},[_c('img',{attrs:{"src":require("@/assets/ico_cloth.svg")}}),_c('img',{attrs:{"src":require("@/assets/ico_cloth_on.svg")}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef4bd8a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/status/Clothing.vue
// module id = null
// module chunks = 